@if (isDesktop$ | async) {
  <rl-topnav [(navOpen)]="navOpen" [user]="(user$ | async)?.user" [role]="(user$ | async)?.role" [routes]="breadcrumbs$ | async" (openUser)="openUser()"></rl-topnav>
  <rl-sidebar [open]="navOpen" [groups]="componentStore.groups$ | async"></rl-sidebar>
}

<div [class.inset]="isDesktop$ | async">
  <router-outlet></router-outlet>
</div>
